export const CSS_FILE_NAMES = {
    global: 'assets/css/global.css',
    component: 'assets/css/component.css',
    fontFace: 'assets/css/font-face.css',
    typography: 'assets/css/typography.css',
    custom: 'assets/css/custom.css',
    mediaQuery: 'assets/css/media-query.css',
};
